import { Link, useNavigate } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();

  // Scrolls to top — used for Home link
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // Navigates to /services then scrolls to specific card
  function goToService(id) {
    window.scrollTo({ top: 0, behavior: "instant" });
    navigate("/services");
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
  }

  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* ── Brand column ── */}
        <div className="footer-col footer-brand">
          <img src="/keystonelogo.png" alt="Keystone Insurance Brokers" className="footer-logo" />
          <p>
            Independent insurance brokers serving Surrey and Greater Vancouver
            for over 20 years. We shop the market so you don't have to.
          </p>
        </div>

        {/* ── Quick links ── */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
            <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
            <li><Link to="/services" onClick={scrollToTop}>Services</Link></li>
            <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>
          </ul>
        </div>

        {/* ── Services ── */}
        <div className="footer-col">
          <h4>Our Services</h4>
          <ul>
            <li><button className="footer-service-btn" onClick={() => goToService("auto-insurance")}>Auto Insurance</button></li>
            <li><button className="footer-service-btn" onClick={() => goToService("home-insurance")}>Home Insurance</button></li>
            <li><button className="footer-service-btn" onClick={() => goToService("business-insurance")}>Business Insurance</button></li>
            <li><button className="footer-service-btn" onClick={() => goToService("travel-insurance")}>Travel Insurance</button></li>
          </ul>
        </div>

        {/* ── Contact info ── */}
        <div className="footer-col">
          <h4>Contact Us</h4>
          <ul className="footer-contact">
            <li>
              <MapPin size={14} />
              <span>103-8077 King George Blvd,<br />Surrey, BC V3W 5B4</span>
            </li>
            <li>
              <Phone size={14} />
              <a href="tel:6045958666">(604) 595-8666</a>
            </li>
            <li>
              <Mail size={14} />
              <a href="mailto:Keystoneins@shaw.ca">Keystoneins@shaw.ca</a>
            </li>
          </ul>
          <div className="footer-hours">
            <span>Mon–Fri: 9:00 AM – 8:00 PM</span>
            <span>Sat–Sun: 10:00 AM – 7:00 PM</span>
          </div>
        </div>

      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Keystone Insurance Brokers Ltd. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link>
          <Link to="/terms" onClick={scrollToTop}>Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;